import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useSelected } from '../company/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useDownloadVaultFile = () => {
  const { selectedCompanyId: companyId } = useSelected();
  const { mutate: downloadVaultFile } = useAppMutation([QueryKey.VAULT_FILE_DOWNLOAD, companyId], {
    mutationFn: async ({ fileId }: { fileId: string }) => {
      await ApiService.downloadFile(
        {
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'vault', 'files', fileId, 'view'],
        },
        { queryParams: { attachment: true } },
      );
    },
  });

  return { downloadVaultFile };
};
